import * as React from "react";
import { RouteComponentProps } from "react-router-dom";

import { getAppFacilities } from "webapp/lib/app-renderer";
import { AccessSupportCodeBody } from "common/firebase-function-types";
import { assertNever, checkString, dontAwait, isResponseOK } from "common/Support";
import { showErrorModal } from "designer/ui/smart/modals/modals";

interface RouteProps {
    readonly code: string | undefined;
}

interface Props extends RouteComponentProps<RouteProps> {}

enum Progress {
    Starting,
    WaitingForAuth,
    Sent,
}

interface State {
    readonly progress: Progress;
}

export default class SupportCodeScreen extends React.PureComponent<Props, State> {
    public state: State = { progress: Progress.Starting };

    private async tryAccessCode(): Promise<void> {
        const appFacilities = getAppFacilities();

        if (!(await appFacilities.isSignedInToFirebase())) {
            this.setState({ progress: Progress.WaitingForAuth });
            setTimeout(() => dontAwait(this.tryAccessCode()), 200);
            return;
        }

        const { code } = this.props.match.params;
        if (code === undefined) return;

        const body: AccessSupportCodeBody = { code };
        const response = await appFacilities.callAuthCloudFunction("accessSupportCode", body);
        if (!isResponseOK(response)) {
            await showErrorModal("Could not access support code");
            return;
        }

        const { url } = await response.json();
        window.location.href = checkString(url);
    }

    public componentDidMount(): void {
        dontAwait(this.tryAccessCode());
    }

    public render(): React.ReactNode {
        const { progress } = this.state;
        switch (progress) {
            case Progress.Starting:
            case Progress.WaitingForAuth:
                return <div>Waiting to be authenticated.</div>;
            case Progress.Sent:
                return <div>Accessing the support code.</div>;
            default:
                return assertNever(progress);
        }
    }
}
